import React, {useContext} from 'react';
import CloseIcon from "components/icons/CloseIcon";
import {ReactComponent as BurgerIcon} from "assets/img/burger_menu.svg";

import {ReactComponent as EyeIcon} from "assets/img/eye.svg";
import {black500} from "assets/jss/main";

import {SidebarContext} from "../../../SidebarContext";

function MobileCurrentOrganization(props) {
    const {currentOrganization, isSidebarOpen, setOpenSidebar, closeSidebar} = useContext(SidebarContext);

    if (!currentOrganization) {
        return null;
    }
    return (
        <div style={{
            padding: '20px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
        }}>
            <div style={{
                fontSize: '16px',
                fontWeight: 600,
                color: black500
            }}>
                {currentOrganization.name}
            </div>
            <div style={{
                display: 'flex',
                alignItems: 'center'
            }}>
                <EyeIcon
                    onClick={() => window.open(currentOrganization.eshopUrl, '_blank')}
                    style={{marginRight: '22px'}}
                />
                {isSidebarOpen ? (
                    <CloseIcon
                        color={black500}
                        size={21}
                        onClick={() => closeSidebar()}
                    />
                ) : (
                    <BurgerIcon
                        onClick={() => setOpenSidebar()}
                    />
                    )}

            </div>
        </div>
    );
}

export default MobileCurrentOrganization;
